module.exports = __webpack_public_path__ + "9ce3ff39c67b50e54516471238b1bbdd.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/share-slogan-5.png
// module id = 505
// module chunks = 0